import React from 'react'
import { Stack, Text, Box } from '@mantine/core'
import { IconFileSearch, IconSearch } from '@tabler/icons-react'
import { useTheme } from '../../components/ThemeProvider'

interface EmptyStateProps {
  type: 'initial' | 'no-results'
}

export default function EmptyState({ type }: EmptyStateProps) {
  const theme = useTheme()

  if (type === 'initial') {
    return (
      <Box p="xl" mt="xl">
        <Stack align="center" gap="lg">
          <Box
            style={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              background: `${theme.primaryColor}10`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IconSearch size={60} color={theme.primaryColor} opacity={0.5} />
          </Box>

          <Stack align="center" gap="xs">
            <Text size="lg" fw={600} c="gray.7">
              请输入手机号查询推广报告
            </Text>
            <Text size="sm" c="dimmed">
              支持查询代理商的授权模板列表
            </Text>
          </Stack>
        </Stack>
      </Box>
    )
  }

  return (
    <Box p="xl" mt="xl">
      <Stack align="center" gap="lg">
        <Box
          style={{
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: `${theme.primaryColor}10`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconFileSearch size={60} color={theme.primaryColor} opacity={0.5} />
        </Box>

        <Stack align="center" gap="xs">
          <Text size="lg" fw={600} c="gray.7">
            暂无查询结果
          </Text>
          <Text size="sm" c="dimmed">
            该手机号未找到推广授权记录
          </Text>
        </Stack>
      </Stack>
    </Box>
  )
}
